<template>
  <th
    :style="[styleWidth]"
    :class="[
      col.cssCellClass,
      {empty: !col.caption, 'sticky lock': col.lock},
      String(col.align || ''),
      'ms-col-th',
      dbOptionHeight ? 'flow-hidden' : '',
    ]"
    :field="col.dataField"
  >
    <div :class="filterable ? 'flex-column' : ''" :style="filterable ? 'height: 100%;' : ''">
      <div :class="['ms-th-content flex-row', 'flex']">
        <div
          @click="sort"
          class="ms-th-title flex flex-row"
          :title="col.tooltip || col.title || col.definition || col.caption"
          :class="[
            {
              'has-lock': col.lockable !== false,
              'has-sort': col.sortable !== false,
              'pdl-10': col.lockable === false,
              'pdr-10': !col.sortable,
              'height-group': col.group,
            },
            dbOptionHeight == 'heightoptionvalue1' ? 'fs-small' : 'fs-big',
          ]"
        >
          <div
            v-if="col.lockable !== false && !col.group"
            class="icon24 lock"
            :class="{locked: col.lock}"
            @click="lockClick"
          ></div>
          <!-- v-tooltip="col.tooltip " -->
          <span :class="['flex', `text-${col.align || 'left'}`, col.cssClass]">{{ col.caption }}</span>
          <div
            class="icon24 mi-arrow-dropdown ml5 mr0"
            :class="[
              {sort: sortStatus == $ms.constant.SortStatus.none},
              {'sort-desc': sortStatus == $ms.constant.SortStatus.desc},
              {'sort-asc': sortStatus == $ms.constant.SortStatus.asc},
            ]"
            @click.stop="sort"
            v-if="col.sortable !== false"
          ></div>
          <slot name="widget-button-th"></slot>
        </div>

        <!-- <div
        class="ms-lock"
        :class="{ locked: col.lock }"
        v-if="col.lockable !== false && false"
        @click="lockClick"
      ></div> -->
        <div class="ms-resize" @mouseup="resizeOff" @mousedown="resizeOn" v-if="resizeCol"></div>
      </div>
      <template v-if="filterable">
        <!-- nvtoan2 25/10/2023 -->
        <!-- logic đoạn này là ntn: ban đầu code nó case v-if-else theo biến disabled, 
          nhưng bug 387370 nvtoan2 sửa thì khi chọn tất cả sẽ không xóa filter đi => k dùng v-if được, 
          Mà k tự tin sửa về v-show, sợ ảnh hưởng tới những thằng dùng biến disable cũ, 
          nên tạo ra biến mới và case kiểu hơi đần ntn -->
        <component
          v-if="col.filterable && filterComponentName && (!disabled || disabledSelectedAll)"
          v-show="!disabledSelectedAll"
          ref="cpnFilter"
          :is="filterComponentName"
          :col="col"
          @filter-header="filterHeaderHandle"
          @load-filter-header="loadFilterHeaderHandle"
          @scroll-end-combobox-local="() => scrollEndComboboxLocal(col)"
          @before-expand-click="() => beforeExpandClick(col)"
          @handle-input-text="(value) => handleInputTextCombo(value, col)"
          :propsData="propsData"
          :dbOptionHeight="dbOptionHeight"
          :filterIconClass="filterIconClass"
        ></component>
        <div v-else :class="['filter-container-empty', dbOptionHeight]"></div>
        <div v-show="disabledSelectedAll" :class="['filter-container-empty', dbOptionHeight]"></div>
      </template>
    </div>
  </th>
</template>
<script>
import {defineComponent, onMounted, ref, getCurrentInstance, computed} from 'vue';
import {useColumnResize} from '@/setup/grid/resizeColumn.js';

//FilterComponent
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import msThText from './columnOption/MsThOptionText.vue';
import msThBoolean from './columnOption/MsThOptionBoolean.vue';
import msThNumber from './columnOption/MsThOptionNumber.vue';
import msThDate from './columnOption/MsThOptionDate.vue';
import msThEnum from './columnOption/MsThOptionEnum.vue';
import msThCombobox from './columnOption/MsThOptionCombobox.vue';
import msThTime from './columnOption/MsThOptionTime.vue';

export default defineComponent({
  name: 'msTh',
  components: {
    msThText,
    msThBoolean,
    msThNumber,
    msThDate,
    msThEnum,
    msThCombobox,
    msThTime,
  },
  props: {
    col: {},
    data: {},
    resizeCol: {
      default: true,
      type: Boolean,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    moduleAutocomplete: {
      type: String,
      default: null,
    },
    propsData: {
      default: {},
      type: Object,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    disabledSelectedAll: {
      default: false,
      type: Boolean,
    },
    isHeaderHaveGroup: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['resizeOn', 'resizeOff', 'changeColumnResize', 'sort', 'changeLock', 'filter', 'loadFilter'],
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    let filterComponentName = ref(null);
    let cpnFilter = ref(null);

    //Lấy hàm trong fn chung
    const {getFilterType} = setup(props, {emit});

    //Hooks
    /**
     * Build component filter theo data type control
     * HTHIEP 14.03.2022
     */
    onMounted(() => {
      filterComponentName.value = getFilterType(props.col);
      widthx.value = props.col._width;
    });

    /**
     * Trigger sự kiện filter từ con
     * HTHIEP 14.03.2022
     */
    const filterHeaderHandle = value => {
      emit('filter', {col: props.col, value});
    };

    /**
     * Load combobox header
     */
    const loadFilterHeaderHandle = (payload, row, dataField) => {
      emit('loadFilter', payload, row, dataField);
    };

    /**
     * scroll combobox header local data
     */
    const scrollEndComboboxLocal = (col) => {
      emit('scrollEndComboboxLocal', col);
    };
    /**
     * Xổ combobox header 
     */
    const beforeExpandClick = (col) => {
      emit('beforeExpandClick', col);
    };
    /**
     * input combobox header 
     */
    const handleInputTextCombo = (value, col) => {
      emit('handleInputTextCombo', {text: value, col: col});
    };

    /**
     * Xóa giá trị trên cột filter
     * HTHIEP 14.03.2022
     */
    const removeFilter = (trigger = true) => {
      cpnFilter.value.removeFilter(trigger);
    };

    const {sortStatus, styleWidth, sort, lockClick, updateColWidth, resizeOn, widthx, resizeOff} = useColumnResize({
      props,
      emit,
    });
    const dbOptionHeight = computed(() => {
      // if (!proxy.filterable) {
      //   return 'heightoptionvalueWOfilter' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
      // } else
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });

    const filterIconClass = computed(() => {
      if (
        props?.col?.formatType == proxy.$ms.constant.FormatType.ComboboxAmount &&
        props?.col?.columnType == 'ColumnNumber'
      ) {
        return 'ic-filter-equal';
      } else if (props?.col?.formatType == proxy.$ms.constant.FormatType.Enum && props?.col?.queryMode == 'remote') {
        return 'ic-filter-contain';
      }
      // Return undifined thì sẽ lấy mặc định pops default ở componemt con
      return undefined;
    });
    return {
      styleWidth,
      sortStatus,
      filterComponentName,
      cpnFilter,
      sort,
      lockClick,
      updateColWidth,
      resizeOn,
      filterHeaderHandle,
      loadFilterHeaderHandle,
      removeFilter,
      resizeOff,
      dbOptionHeight,
      filterIconClass,
      scrollEndComboboxLocal,
      beforeExpandClick,
      handleInputTextCombo,
    };
  },
  methods: {},
});
</script>

<style lang="scss">
li.filter-operator-item {
  align-items: center;
  &.active {
    background-color: #e2f2ff;
  }
}
.flow-hidden {
  overflow: hidden;
}
.fs-small {
  font-size: $font-size-custom-small;
}
.fs-big {
  font-size: $font-size-custom-big;
}
.ms-th {
  .filter-container-empty {
    height: $ms-filter-grid-height;
    border-top: 1px solid $ms-th-grid-border-color;
    background: #fff;
  }
  .filter-container {
    height: $ms-filter-grid-height;
    border-top: 1px solid $ms-th-grid-border-color;
    .menu-wrapper {
      &.active button {
        background-color: #e2f2ff;
      }
    }

    &.filter-container-boolean {
      .filter-value {
        background: #fff;
      }
    }
    .filter-op {
      position: relative;
      z-index: 2;

      .btn-filter-operator {
        height: $ms-filter-item-grid-height;
        width: $ms-filter-operator-grid-width;
        border: none;
        border-right: 1px dotted $ms-th-grid-border-color;
        background: #fff;
        padding: 0;
        padding-left: 3px;
        cursor: pointer;
        &:focus,
        &:active,
        &:focus-visible {
          outline: none;
        }
        .heightoptionvalue1 {
        }
        &.heightoptionvalue2 {
          min-height: 24px !important;
        }
      }
    }
    .filter-value {
      .ms-input-filter-value {
        &.heightoptionvalue1 {
          .ms-calendar-small::before {
            width: 20px !important;
            height: 20px !important;
            background-position: 0px -99px !important;
          }
        }
        .ms-input-item,
        .ms-number-item,
        .ms-input--datepicker,
        .combo-box-input input {
          height: $ms-filter-item-grid-height;
          border-radius: 0;
          &:focus {
            outline: none;
          }
          &.heightoptionvalue1 {
            height: 19px !important;
            min-height: 19px !important;
          }
          &.heightoptionvalue2 {
            height: $input-height-custom-small-with-border !important;
            min-height: $input-height-custom-small-with-border !important;
          }
        }

        .ms-container--datepicker {
          &:hover {
            .ms-calendar:not(.disabled),
            .ms-calendar-filter-grid:not(.disabled),
            .ms-calendar-small:not(.disabled),
            .ms-calendar-small-filter-grid:not(.disabled) {
              &::before {
                display: block;
              }
            }
          }

          .ms-calendar,
          .ms-calendar-filter-grid,
          .ms-calendar-small-filter-grid,
          .ms-calendar-small {
            &::before {
              display: none;
            }

            &.disabled:before {
              background-position: -17px -137px;
            }
          }
        }
        .combo-box-input div div {
          background: #fff;
        }
        .icon-combo--dropdown {
          height: $ms-filter-item-grid-height;
          background: #fff;
          border-left: 1px dotted $ms-th-grid-border-color;
          border-radius: 0;
        }
      }
      position: relative;
      z-index: 1;
    }
    .icon-combo--dropdown-small {
      width: 20px !important;
      height: 20px !important;
      background-color: $white;
      &::before {
        width: 20px !important;
        height: 20px !important;
        background-position: -337px -49px;
      }
    }
  }

  .sort::before {
    background-position: -48px -120px;
  }
  .sort-desc::before {
    background-position: 0 -120px;
  }
  .sort-asc::before {
    background-position: -24px -120px;
  }
  .heightoptionvalue1 {
    &.filter-container,
    &.btn-filter-operator {
      height: 20px !important;
      min-height: 20px !important;
      // width: 20px !important;
    }

    .ms-td {
      .ms-td-normal-span {
        height: $input-height-custom-small-no-border !important;
      }
    }
    &.filter-container-empty {
      height: 20px !important ;
      min-height: 20px !important;
    }
  }
  .heightoptionvalue2 {
    &.filter-container,
    &.btn-filter-operator {
      height: $input-height-custom-small-no-border !important;
      min-height: $input-height-custom-small-no-border !important;
      // width: $input-height-custom-small-no-border !important;
    }
    .ms-td {
      .ms-td-normal-span {
        height: $input-height-custom-big-no-border !important;
      }
    }
    &.filter-container-empty {
      height: $input-height-custom-small-no-border !important;
      min-height: $input-height-custom-small-no-border !important;
    }
  }
}
</style>
